// extracted by mini-css-extract-plugin
export var activeDot = "FeaturedBlogs-module--activeDot--08d54";
export var arrow = "FeaturedBlogs-module--arrow--00b83";
export var buttons = "FeaturedBlogs-module--buttons--cad9c";
export var container = "FeaturedBlogs-module--container--75ab7";
export var dot = "FeaturedBlogs-module--dot--459d6";
export var dots = "FeaturedBlogs-module--dots--db295";
export var innerButtons = "FeaturedBlogs-module--innerButtons--eb5db";
export var innerDots = "FeaturedBlogs-module--innerDots--13d0a";